<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GC2jEn/tc-custom/9781504089531.jpg?1708750477007" alt="This image is the cover for the book Murders at the Rookery Grange Retreat, The Prunella Pearce Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Murders at the Rookery Grange Retreat, The Prunella Pearce Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>Residents of a rest home are dying of very unnatural causes, in this new novel in a series of “warm, cozy crime capers” (<i>Jill’s Book Cafe</i>).</b><br/><br/><i>Christmas Eve, 1989. </i>A couple is found slumped in front of their twinkling Christmas tree in an apparent murder-suicide . . .<br/><br/><i>Today</i>. Librarian Pru Pearce is preparing for her wedding to police detective Andy Barnes. But after one of her Women’s Institute friends suffers a suspicious accident at Rookery Grange, a home for the elderly and infirm, Pru and the other ladies are on alert. And when one of the residents is asphyxiated with a pillow, no one can rest easy . . .<br/><br/> With her wedding taking a disastrous turn and a killer on the loose, the part-time detective makes another vow: to investigate and solve the mystery. Will she unravel generations of murderous secrets and find the culprit?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gina Kirkham
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9a2461a0